import { render, staticRenderFns } from "./FixedBottom.vue?vue&type=template&id=c3bb3a30"
import script from "./FixedBottom.vue?vue&type=script&lang=js"
export * from "./FixedBottom.vue?vue&type=script&lang=js"
import style0 from "./FixedBottom.vue?vue&type=style&index=0&id=c3bb3a30&prod&lang=css"


/* normalize component */
import normalizer from "!../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports